import React from 'react'
import { Box, Typography as Typo } from '@material-ui/core'

export default function NotFound() {
    return (
        <Box>
            <Typo variant={'h2'}>404 page is not found</Typo>
        </Box>
    )
}
